module.exports = __webpack_public_path__ + "img/user-panel-mobile.c8439ea5.jpg";